import { render, staticRenderFns } from "./Checklists.vue?vue&type=template&id=2e3b0cb2&"
import script from "./Checklists.vue?vue&type=script&lang=js&"
export * from "./Checklists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports